<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID" :style="{ 'background-color': item.IsNoname ? 'rgb(155 200 255)' : '#ffffff' }">
                <td>{{ item.ID }}</td>
                <td>{{ getStaffName(item.SaleID) }}</td>
                <td>{{ item.Username }}</td>
                <td>{{ item.Receiver }}</td>
                <td>{{ item.Phone }}</td>
                <td v-if="!saleRole && (item.Status != status_enum.Hoan_thanh || adminRole) && item.Amount">
                  <v-edit-dialog :return-value.sync="item.Status" large lazy persistent @save="saveItem({ID: item.ID, Action: 'update_status', Status: item.Status})">
                    <div v-bind:style="{ 'color': get_status_color(item.Status, status_list)}">{{ item.Status | display_value(status_list) }}</div>
                    <template v-slot:input>
                        <v-select v-model="item.Status" :items="status_list" item-text="name" item-value="value" label="Trạng thái" single-line autofocus></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-else v-bind:style="{ 'color': get_status_color(item.Status, status_list)}">{{ item.Status | display_value(status_list) }}</td>
                <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                <td class="text-right">{{ item.Volume | currency('', 2) }}</td>
                <td class="text-right">{{ item.NumberOfPack | currency }}</td>
                <td class="text-right">{{ item.Amount | currency }}</td>
                <td>{{ item.CreatedDate | display_date }}</td>
                <td>{{ item.ExportDate | display_date }}</td>
                <td>{{ item.Note }}</td>
                <td>{{ item.CreatedBy }}</td>
                <td>{{ item.ExportedBy }}</td>
                <td class="text-center">
                  <v-icon medium :disabled="saleRole || item.Status != status_enum.Da_xuat_kho" class="mr-2" @click="saveItem({ID: item.ID, Action: 'update_status', Status: status_enum.Hoan_thanh})">check</v-icon>
                  <v-icon medium class="mr-2" @click="saveItem({ID: item.ID, Action: 'update_amount'})">refresh</v-icon>
                  <v-icon medium v-if="item.Status != status_enum.Hoan_thanh" class="mr-2" @click="gotoDetail(item.ID)">edit</v-icon>
                  <v-icon medium v-else class="mr-2" @click="gotoDetail(item.ID)">visibility</v-icon>
                  <v-icon medium class="mr-2" color="red darken-2" @click="printLabel(item.ID)">print</v-icon>
                  <v-icon medium :disabled="item.Status >= status_enum.Da_xuat_kho" @click="deleteItem(item.ID)">delete</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>      
      <v-dialog v-model="dialogPackageDetail" persistent max-width="70%">
        <v-card>
          <v-card-title>
            <span class="title">Yêu cầu xuất kho</span>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap pa-3>
              <v-flex lg7 md7 sm7>
                <v-layout row wrap pa-3>
                  <!-- <v-flex lg6 md6 sm12 pa-0 ma-0>
                    <v-checkbox label="Sử dụng máy đọc barcode" v-model="useBarcodeReader"></v-checkbox>
                  </v-flex>
                  <v-flex lg6 md6 sm12 pa-0 ma-0>
                    <v-checkbox label="Không kiểm tra thông tin khách" v-model="ignoreCheckCustomer"></v-checkbox>
                  </v-flex>
                  <v-flex lg12 md12 sm12 pa-0>
                    <v-text-field
                      label="Mã vận đơn"
                      ref="trancode"
                      v-model="currentTransactionCode"
                      class="input-group--focused"
                      @input="codeChanged"
                      @keyup.enter="manualChanged"
                      :disabled="currentItem.Status == status_enum.Da_xuat_kho"
                    ></v-text-field>
                  </v-flex> -->
                  <v-flex lg12 md12 sm12 pa-0>
                    <v-data-table
                      :headers="detail_headers"
                      :items="currentItem.Packages"
                      :server-items-length="currentItem.Packages.length"
                      :options.sync="pagination"
                      :footer-props="items_per_page"
                      :must-sort="true"
                      :loading="loading"
                      :mobile-breakpoint="100"
                    >
                      <template v-slot:item="{ item }">
                        <tr :style="{ 'background-color': item.IsNoname ? 'rgb(155 200 255)' : '#ffffff' }">
                          <td>{{ item.TransactionCode }}</td>
                          <td class="text-right">{{ item.Weight | currency('', 1)}}</td>
                          <td class="text-right">{{ item.Volume | currency('', 2)}}</td>
                          <td class="text-center">
                            <v-icon v-if="currentItem.Status < status_enum.Da_xuat_kho" small @click="deleteTransaction(item.ID)">delete</v-icon>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex lg5 md5 sm5 pl-3 pr-2>
                <v-layout row wrap pl-5>
                  <v-flex lg12 md12 sm12 pa-0>
                    <v-select label="Trạng thái" v-model="currentItem.Status" :items="status_list" item-text="name" item-value="value" readonly></v-select>
                  </v-flex>
                  <v-flex lg12 md12 sm12 pa-0>
                    <v-autocomplete label="Khách hàng" v-model="currentItem.UID" :items="customers" :item-text="getUsername" item-value="ID" @change="onCustomerChanged" :readonly="currentItem.Status == status_enum.Hoan_thanh"></v-autocomplete>
                  </v-flex>
                  <v-flex lg12 md12 sm12 pa-0>
                    <v-text-field
                      label="Người nhận"
                      v-model="currentItem.Receiver"
                      class="input-group--focused"
                      :readonly="currentItem.Status == status_enum.Hoan_thanh"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg12 md12 sm12 pa-0 pt-3>
                    <v-text-field
                      label="Địa chỉ nhận"
                      v-model="currentItem.Address"
                      class="input-group--focused"
                      :readonly="currentItem.Status == status_enum.Hoan_thanh"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg12 md12 sm12 pa-0 pt-3>
                    <v-text-field
                      label="Điện thoại người nhận"
                      v-model="currentItem.Phone"
                      class="input-group--focused"
                      :readonly="currentItem.Status == status_enum.Hoan_thanh"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg12 md12 sm12 pa-0 pt-3>
                    <v-text-field
                      label="Tổng cân"
                      type="number"
                      step=".1"
                      v-model="currentItem.Weight"
                      class="input-group--focused"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg12 md12 sm12 pa-0 pt-3>
                    <v-text-field
                      label="Tổng khối"
                      type="number"
                      step=".2"
                      v-model="currentItem.Volume"
                      class="input-group--focused"
                      readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="closePopup">Đóng</v-btn>
            <v-btn v-if="currentItem.Status == status_enum.Cho_xuat_kho && currentItem.Amount" color="blue darken-1" text @click="exportReceipt">Xuất kho</v-btn>
            <v-btn v-if="currentItem.Status == status_enum.Cho_xuat_kho" color="blue darken-1" text @click="saveData">Lưu lại</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, hasFeatureEditPermission } from "@/commons/utils";
import { print_export_receipt_order } from '@/commons/hpod';
import createPermissionMixin from "@/mixins/permissionMixin";
import _ from "lodash";

export default {
  mixins: [createPermissionMixin('export_receipt')],
  components: {
    "hpo-filter": Filtering
  },
  data() {
    return {
      ignoreCheckCustomer: 0,
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "exportReceipt_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogPackageDetail: false,
      status_list: configs.RECEIPT_STATUS,
      status_enum: configs.RECEIPT_STATUS_ENUM,
      package_status_enum: configs.PACKAGE_STATUS_ENUM,
      useBarcodeReader: false,
      currentTransactionCode: '',
      detail_headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Cân nặng",
          value: "Weight",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Số khối",
          value: "Volume",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Thao tác",
        }
      ],
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      items: state => state.exportReceipt.all.data,
      total_rows: state => state.exportReceipt.all.total,
      currentItem: state => state.exportReceipt.selected,
      loading: state => state.exportReceipt.loading,
      customers: state => state.customer.master.data,
      sales: state => state.staff.all.data,
    }),
    saleRole() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Sale;
    },
    adminRole() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
    },
    userRole() {
      return this.$store.state.authentication.user.roleid;
    },
    headers() {
      let hd = [
        {
          text: "ID",
          value: "ID",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Nhân viên sale",
          value: "SaleID",
          filterable: true,
          values: _.map(this.sales, (item) => {
              return {
                  value: item.ID,
                  name: item.FullName,
              };
          }) || [],
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Khách hàng",
          value: "Username",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Người nhận",
          value: "Receiver",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Điện thoại",
          value: "Phone",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.RECEIPT_STATUS,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "KG",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "M3",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Số kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Thành tiền",
          value: "Amount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Ngày tạo",
          value: "CreatedDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Ngày xuất",
          value: "ExportDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Ghi chú",
          value: "Note",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Người tạo",
          value: "CreatedBy",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Người xuất",
          value: "ExportedBy",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          width: 180,
          sortable: false,
          filterable: false
        }
      ];
      return hd;
    },
  },
  methods: {
    printLabel(id) {
      this.$store.dispatch("exportReceipt/getDetail", id).then(p => {
        const content = print_export_receipt_order(this.currentItem, this.currentItem.Packages, true)
        var mywindow = window.open("", "PRINT");
        mywindow.document.write(content);
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
      });
    },
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("exportReceipt/getList", param);
      this.$store.dispatch("staff/getList", {filter:[{column: "RoleID", value: configs.ROLE_TYPE.Sale, condition: "equal"}]});
      this.getCustomerList();
    },
    gotoDetail: function(id) {
      this.$store.dispatch("exportReceipt/getDetail", id);
      setTimeout(() => {this.dialogPackageDetail = true}, 200);
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData() {
      this.$store.commit("exportReceipt/setDetail", {
        'data': {
          ID: 0,
          Status: 0,
          Packages: []
        }
      });
      this.dialogPackageDetail = true;
    },
    saveItem(item) {
      this.$store.dispatch("exportReceipt/setDetail", {
        'data': item,
        'id': item.ID
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogPackageDetail = false;
    },
    exportReceipt() {
      this.currentItem.Status = this.status_enum.Da_xuat_kho;
      this.saveItem(this.currentItem);
      this.dialogPackageDetail = false;
    },
    closePopup() {
      this.dialogPackageDetail = false;
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
          is_master: 1,
          fields: ["ID", "Username", "FullName", "PhoneNumber", "Address"]
      });
    },
    codeChanged() {
      if(this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    manualChanged(){
      this.appendTransactionCode();
    },
    appendTransactionCode: _.debounce(
      function() {
        var param = {
            filter: [{
                column: "TransactionCode",
                value: this.currentTransactionCode,
                condition: "s_equal"
            }]
        };
        const checkTran = _.find(this.currentItem.Packages, {TransactionCode: this.currentTransactionCode})
        if(checkTran) {
          this.currentTransactionCode = "";
          this.$nextTick(() => this.$refs.trancode.focus());
          sendErrorNotice('Mã vận đơn đã tồn tại trong yêu cầu xuất kho.')
          return;
        }
        this.$store.dispatch("storeManager/getList", param).then(ret => {
          if(ret.data.length > 0) {
            if(ret.data[0].ExportReceiptID) {
              sendErrorNotice(`Mã vận đơn đã tồn tại trong yêu cầu xuất kho #${ret.data[0].ExportReceiptID}.`);
            }
            else {
              if(ret.data[0].UID > 0 && !this.currentItem.UID) {
                this.currentItem.UID = ret.data[0].UID;
                this.onCustomerChanged();
              }
              else if(this.ignoreCheckCustomer && ret.data[0].UID > 0 && this.currentItem.UID != ret.data[0].UID) {
                sendErrorNotice('Mã vận đơn thuộc khách hàng khác.');
                return;
              }
              this.currentItem.Packages.unshift(ret.data[0]);
              this.currentItem.Weight = _.sumBy(this.currentItem.Packages, 'Weight');
              this.currentItem.Volume = _.sumBy(this.currentItem.Packages, 'Volume');
            }
            this.currentTransactionCode = "";
            this.$nextTick(() => this.$refs.trancode.focus());
          }
          else {
            sendErrorNotice('Mã vận đơn không tồn tại.')
          }
        });
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
    deleteTransaction(id) {
      this.currentItem.Packages = this.currentItem.Packages.filter(item => item.ID !== id);
    },
    onCustomerChanged() {
      let cus = _.find(this.customers, {'ID': this.currentItem.UID});
      if(cus) {
        this.currentItem.Username = cus.Username;
        this.currentItem.Receiver = cus.Username;
        this.currentItem.Address = cus.Address;
        this.currentItem.Phone = cus.PhoneNumber;
        if(!this.useBarcodeReader) {
          var param = {
            filter: [{
                column: "UID",
                value: this.currentItem.UID,
                condition: "equal"
            },
            {
                column: "Status",
                value: this.package_status_enum.DA_NHAP_KHO,
                condition: "equal"
            },
            {
                column: "ExportReceiptID",
                value: 0,
                condition: "equal"
            }]
          };
          this.currentItem.Packages = [];
          this.$store.dispatch("storeManager/getList", param).then(ret => {
            if(ret.data.length > 0) {
              for(var i = 0; i < ret.data.length; i++) {
                this.currentItem.Packages.unshift(ret.data[i]);
              }
              this.currentItem.Weight = _.sumBy(this.currentItem.Packages, 'Weight');
              this.currentItem.Volume = _.sumBy(this.currentItem.Packages, 'Volume');
            }
            else {
              sendErrorNotice('Khách hàng không có kiện nhập kho.')
            }
          });
        }
      }
    },
    getUsername(item) {
      return `${item.Username} - ${item.FullName}`;
    },
    getStaffName(id) {
      const staff = _.find(this.sales, { ID: id });
      return staff ? staff.FullName : "";
    },
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("exportReceipt/removeDetail", id);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
